




import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


function LandingPage() {
  const navigate = useNavigate();
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    // 1. Initialize Particles Background
    const initParticles = () => {
      if (window.particlesJS) {
        window.particlesJS("particles-js", {
          particles: {
            number: { value: 70, density: { enable: true, value_area: 800 } },
            color: { value: "#ffffff" },
            opacity: { value: 0.15, random: true },
            size: { value: 1.5, random: true },
            line_linked: { enable: true, distance: 150, color: "#ffffff", opacity: 0.1, width: 1 },
            move: { enable: true, speed: 0.6, direction: "none", random: true, out_mode: "out" }
          },
          interactivity: {
            events: { onhover: { enable: true, mode: "grab" } },
            modes: { grab: { distance: 200, line_linked: { opacity: 0.4 } } }
          }
        });
      }
    };

    if (window.particlesJS) {
      initParticles();
    } else {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/particles.js";
      script.async = true;
      script.onload = initParticles;
      document.body.appendChild(script);
    }

    // 2. Mouse Spotlight Tracking
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;600;800&display=swap" rel="stylesheet" />

      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif; }
        
        body { 
          min-height: 100vh; 
          color: white; 
          overflow: hidden; 
          background: #27e7de; 
        }

        #particles-js {
          position: fixed;
          width: 100%; height: 100%;
          background: #214f55;
          z-index: -1;
        }

        .spotlight {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(91, 117, 187, 0.25) 0%, transparent 50%);
          z-index: -1;
          pointer-events: none;
        }

        .main-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100vh;
          padding: 15px;
        }

        .hero-section {
          text-align: center;
          margin-bottom: 1rem;
          animation: slideDown 0.8s ease-out forwards;
        }

        .hero-section h2 {
          font-size: clamp(1.8rem, 4vw, 2.8rem);
          font-weight: 800;
          letter-spacing: -1px;
          background: linear-gradient(to bottom, #f3e8e8 40%, #3582ec 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .login-card {
          width: 100%;
          max-width: 640px;
          max-height: calc(100vh - 180px); 
          padding: 2rem 2.2rem;
          border-radius: 32px;
          background: rgba(201, 75, 75, 0.02);
          backdrop-filter: blur(40px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          box-shadow: 0 40px 80px -20px rgba(0, 0, 0, 0.5);
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
          animation: zoomIn 0.6s ease-out 0.2s forwards;
          opacity: 0;
        }

        .card-inner {
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: rgba(255,255,255,0.1) transparent;
          padding-right: 4px;
        }

        .card-inner::-webkit-scrollbar { width: 4px; }
        .card-inner::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 10px; }

        .brand-header {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 1.8rem;
        }

        /* Container to keep logo centered and bright */
        .brand-logo-container {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-bottom: 10px;
        }

        /* Keeping your existing CSS logo classes for safety, though we use the img now */
        .vgm-logo-css {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 3px;
          margin-bottom: 10px;
        }

        .block {
          width: 16px; height: 16px;
          position: relative;
          clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
        }
        // .red { background: linear-gradient(135deg, #ef4444, #b91c1c); }
        // .orange { background: linear-gradient(135deg, #f59e0b, #d97706); }

        .login-card h1 { font-size: 22px; color: #f8fafc; margin-bottom: 0.5rem; text-align: center;}
        .login-card p { color: #94a3b8; font-size: 14px; margin-bottom: 2rem; line-height: 1.5; text-align: center;}

        .btn-stack { display: flex; flex-direction: column; gap: 12px; }

        .btn {
          width: 100%;
          padding: 15px;
          border-radius: 14px;
          font-weight: 700;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .btn-primary { 
          background: #fbbf24; 
          color: #020617; 
          box-shadow: 0 4px 15px rgba(251, 191, 36, 0.2);
        }
        .btn-primary:hover { 
          background: #f59e0b; 
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(251, 191, 36, 0.3);
        }

        .btn-secondary { 
          background: rgba(255, 255, 255, 0.04); 
          color: white; 
          border: 1px solid rgba(255, 255, 255, 0.1); 
        }
        .btn-secondary:hover { 
          background: rgba(255, 255, 255, 0.08); 
          border-color: rgba(255, 255, 255, 0.2);
        }



        .btn-third{ 
          background: rgba(202, 67, 67, 0.04); 
          color: white; 
          border: 1px solid rgba(255, 255, 255, 0.1); 
        }
        .btn-third:hover { 
          background: rgba(146, 77, 77, 0.08); 
          border-color: rgba(255, 255, 255, 0.2);
        }

        .footer-label {
          margin-top: 1.5rem;
          font-size: 9px;
          color: #ecf2f5;
          letter-spacing: 2px;
          font-weight: 600;
          opacity: 0.7;
        }

        @keyframes slideDown { from { opacity: 0; transform: translateY(-15px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes zoomIn { from { opacity: 0; transform: scale(0.97); } to { opacity: 1; transform: scale(1); } }
      `}</style>

      {/* Visual Effects */}
      <div id="particles-js"></div>
      <div className="spotlight"></div>

      <div className="main-wrapper">
        <header className="hero-section">
          <h2>Commission Agent Lifecycle Management</h2>
        </header>

        <main className="login-card">
          <div className="card-inner">
            <div className="brand-header">
              
              {/* Keeping original logic blocks (commented out so they aren't removed) */}
              {/* <div className="vgm-logo-css">
                <div className="block red"></div>
                <div className="block orange"></div>
                <div className="block orange"></div>
                <div className="block red"></div>
              </div> 
              */}

              <div className="brand-logo-container">
                <img
                    src="/image.png"
                    alt="VGM Logo"
                    style={{ 
                        height: '70px', 
                        width: 'auto', 
                        objectFit: 'contain',
                        // filter: 'brightness(1) invert(2)' 
                    }}
                />
              </div>

            </div>

            <h1> Onboarding Workflow </h1>
            <p>Manage and sign documents anytime, anywhere.</p>

            <div className="btn-stack">
              <button className="btn btn-primary" onClick={() => navigate("/login")}>
                <span>💼</span> CHR Dashboard
              </button>

              <button className="btn btn-secondary" onClick={() => navigate("/login")}>
                <span>👤</span> BHR Dashboard
              </button>

               <button className="btn btn-third" onClick={() => navigate("/login")}>
                <span>👤</span> ACCOUNTS TEAM Dashboard
              </button>     

            </div>
          </div>
        </main>

        <footer className="footer-label">
          © 2026 VGM CONSULTANTS LIMITED
        </footer>
      </div>
    </>
  );
}

export default LandingPage;